import { ChevronDown, ChevronUp } from '@components/icons'
import cn from 'clsx'
import { FC, useState } from 'react'
import { connectSortBy } from 'react-instantsearch-dom'

interface sortByProps {
  items: any[]
  refine: any
}

const COLLAPSED_COUNT = 5

const SortBy: FC<sortByProps> = ({ items, refine }) => {
  const [open, setOpen] = useState(false)
  const [showAll, setShowAll] = useState(false)

  const selected = items.find((item) => item.isRefined)
  const visibleItems = showAll ? items : items.slice(0, COLLAPSED_COUNT)

  return (
    <div className="border-b border-ui-grey-25">
      <button
        type="button"
        aria-expanded={open}
        className="w-full flex items-start justify-between py-5 text-left"
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="flex flex-col">
          <span className="body-1-bold text-text-base">Sort by</span>
          {!open && selected && (
            <span className="mt-1 body-1 text-text-disabled">
              {selected.label}
            </span>
          )}
        </span>
        <span className="pt-1 shrink-0">
          {open ? <ChevronUp /> : <ChevronDown />}
        </span>
      </button>
      {open && (
        <div className="pb-5">
          <ul className="flex flex-col">
            {visibleItems.map((item) => (
              <li key={item.value}>
                <button
                  type="button"
                  className="flex items-center gap-3 py-2 w-full text-left cursor-pointer"
                  onClick={(event) => {
                    event.preventDefault()
                    refine(item.value)
                  }}
                >
                  <span
                    className={cn(
                      'flex items-center justify-center h-5 w-5 rounded-full border shrink-0',
                      {
                        'border-brand-chrome border-2': item.isRefined,
                        'border-ui-grey-25': !item.isRefined,
                      }
                    )}
                  >
                    {item.isRefined && (
                      <span className="h-2.5 w-2.5 rounded-full bg-brand-chrome" />
                    )}
                  </span>
                  <span className="body-1 text-text-base">{item.label}</span>
                </button>
              </li>
            ))}
          </ul>
          {items.length > COLLAPSED_COUNT && (
            <button
              type="button"
              className="mt-3 body-2 underline text-text-base cursor-pointer"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? 'Show less' : `+ ${items.length - COLLAPSED_COUNT} more`}
            </button>
          )}
        </div>
      )}
    </div>
  )
}

const CustomSortBy = connectSortBy(SortBy)

export default CustomSortBy
